var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSquareWithTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.83864 10.0915L5.51606 7.76896L4.2851 8.99993L7.22316 11.938C7.38647 12.1011 7.60784 12.1927 7.83864 12.1927C8.06945 12.1927 8.29082 12.1011 8.45413 11.938L13.7148 6.67735L12.4838 5.44638L7.83864 10.0915Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8065 0H3.19355C2.34657 0 1.53427 0.336462 0.935368 0.935368C0.336462 1.53427 0 2.34657 0 3.19355V14.8065C0 15.6534 0.336462 16.4657 0.935368 17.0646C1.53427 17.6635 2.34657 18 3.19355 18H14.8065C15.6534 18 16.4657 17.6635 17.0646 17.0646C17.6635 16.4657 18 15.6534 18 14.8065V3.19355C18 2.34657 17.6635 1.53427 17.0646 0.935368C16.4657 0.336462 15.6534 0 14.8065 0ZM16.2581 14.8065C16.2581 15.1914 16.1051 15.5607 15.8329 15.8329C15.5607 16.1051 15.1914 16.2581 14.8065 16.2581H3.19355C2.80856 16.2581 2.43933 16.1051 2.1671 15.8329C1.89487 15.5607 1.74194 15.1914 1.74194 14.8065V3.19355C1.74194 2.80856 1.89487 2.43933 2.1671 2.1671C2.43933 1.89487 2.80856 1.74194 3.19355 1.74194H14.8065C15.1914 1.74194 15.5607 1.89487 15.8329 2.1671C16.1051 2.43933 16.2581 2.80856 16.2581 3.19355V14.8065Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareWithTick);
export default __webpack_public_path__ + "static/media/squareWithTick.dcaddb75.svg";
export { ForwardRef as ReactComponent };